import { Col, Form, InputNumber, Row, Select } from 'antd'
import { Gutter } from 'antd/es/grid/row'
import React, { FunctionComponent } from 'react'

import { BUYBACK_FIELD as FIELD } from '../../../common/buybackTypes'
import {
  UNIT_DISPOSITION_OPTIONS,
  UNIT_UTILITY_OPTIONS,
} from '../../utils/buybackDictionaries'

const gutter: Gutter | [Gutter, Gutter] = [16, 16]
const { Option } = Select

export const BuybackFormUnitFragment: FunctionComponent = () => {
  return (
    <Row gutter={gutter}>
      <Col xs={24} md={6}>
        <Form.Item name={FIELD.UnitDisposition} label="Dispozice">
          <Select className="w-full" placeholder="Vyberte z nabídky">
            {UNIT_DISPOSITION_OPTIONS.map(option => (
              <Option key={option.value} value={option.value}>
                {option.label}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>

      <Col xs={24} md={6}>
        <Form.Item name={FIELD.UnitArea} label="Užitná plocha">
          <InputNumber className="w-full" addonAfter="m²" min={1} />
        </Form.Item>
      </Col>

      <Col xs={24} md={12}>
        <Form.Item name={FIELD.UnitUtility} label="Příslušenství">
          <Select
            className="w-full"
            mode="multiple"
            placeholder="Vyberte z nabídky"
            allowClear
          >
            {UNIT_UTILITY_OPTIONS.map(option => (
              <Option key={option.value} value={option.value}>
                {option.label}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
    </Row>
  )
}
